
import Accordion from '../Accordion/Accordion';
export default function FaqSection() {
  
  return (
    <>
   
        <div className="container px-2 md:px-20 m-auto py-10 " id="faq">
            <h1 className="h1 mb-10">Faq's</h1>
            <div className=" space-y-3">
        <Accordion 
        title="Lorem ipsum dolor sit amet, consectetur adipiscing elit?"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur adipiscing elit"
        />
        <Accordion 
        title="Lorem ipsum dolor sit amet, consectetur adipiscing elit?"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur adipiscing elit"
        />
        <Accordion 
        title="Lorem ipsum dolor sit amet, consectetur adipiscing elit?"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur adipiscing elit"
        />
        <Accordion 
        title="Lorem ipsum dolor sit amet, consectetur adipiscing elit?"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur adipiscing elit"
        />
      
       
        {/* <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                <span>Do you offer technical support?</span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-purple-500`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
                No.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> */}
      </div>
      
      </div>
    </>
  );
}
